import {useRef} from 'react'

export const useOnce = (callback: () => void): void => {
  const doneRef = useRef(false)
  // eslint-disable-next-line react-hooks/refs
  if (doneRef.current) {
    return
  }
  // eslint-disable-next-line react-hooks/refs
  doneRef.current = true
  callback()
}
